import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Artikel } from './stammdaten.service';

@Injectable({
  providedIn: 'root',
})
export class ArtikelService {
  private apiUrl = `${environment.apiUrl}/artikel`;

  constructor(private httpClient: HttpClient) {}

  /**
   * Get all Artikel with pagination
   */
  getArtikels(
    page: number = 1,
    limit: number = 500,
    search: string = '',
    sortBy: string = 'nummer',
    sortOrder: string = 'asc'
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder);

    if (search) {
      params = params.set('search', search);
    }

    return this.httpClient.get<any>(this.apiUrl, { params }).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  /**
   * Get service_pauschale articles (Viertel services) for the Abrechnung selector.
   * Uses the backend art_typ filter and returns the raw list (incl. viertel +
   * preis_pro_viertel + service_periodizitaet).
   */
  getServiceArtikels(): Observable<any[]> {
    const params = new HttpParams()
      .set('limit', '200')
      .set('art_typ', 'service_pauschale')
      .set('sortBy', 'nummer')
      .set('sortOrder', 'asc');
    return this.httpClient.get<{ data: any[] }>(this.apiUrl, { params }).pipe(
      map((response) => response.data || []),
      catchError(this.handleError)
    );
  }

  /**
   * Get single Artikel by ID
   */
  getArtikel(id: number): Observable<Artikel> {
    return this.httpClient.get<{ data: Artikel }>(`${this.apiUrl}/${id}`).pipe(
      map((response) => response.data),
      catchError(this.handleError)
    );
  }

  /**
   * Create new Artikel
   */
  createArtikel(artikel: Partial<Artikel>): Observable<Artikel> {
    return this.httpClient.post<{ data: Artikel }>(this.apiUrl, artikel).pipe(
      map((response) => response.data),
      catchError(this.handleError)
    );
  }

  /**
   * Update existing Artikel
   */
  updateArtikel(id: number, artikel: Partial<Artikel>): Observable<Artikel> {
    return this.httpClient.put<{ data: Artikel }>(`${this.apiUrl}/${id}`, artikel).pipe(
      map((response) => response.data),
      catchError(this.handleError)
    );
  }

  /**
   * Delete Artikel
   */
  deleteArtikel(id: number): Observable<any> {
    return this.httpClient.delete(`${this.apiUrl}/${id}`).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  /**
   * Handle errors
   */
  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
} 